function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCertificationinline = function SvgCertificationinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.922 22.625H.078l1.195-2.363-1.195-2.133h23.844l-1.195 2.133Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#8162aa",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.848 19.441H2.18l3.722-1.824H18.13Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e2322",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.89 20.375 5.887-10.145h-1.101l-5.336 9.192",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#e8282b",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.309 19.422H6.66L1.324 10.23H.223l5.886 10.145h5.239",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#98ca3f",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.324 10.23 5.332-9.195L6.11.078.223 10.23Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#cbdd72",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.34 1.035 5.336 9.195h1.101L17.891.078h-.012l-.547.957Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f07525",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66 1.035h10.672l.547-.957H6.109l.547.957Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f8c519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66 19.422h10.68l5.336-9.192H1.324ZM17.34 1.035h-.008l-.793 1.383.793-1.383H6.656l.29.504-.29-.504-5.332 9.195h21.352Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#e0e1e2",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.195 19.422h19.61v4.5H2.195Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#6389c6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.133 13.953q.165 0 .328.035c.094.02.18.055.266.102v.32a2 2 0 0 0-.286-.086 1.2 1.2 0 0 0-.27-.031 1 1 0 0 0-.284.05.6.6 0 0 0-.25.157.8.8 0 0 0-.18.285c-.05.14-.074.29-.07.438q-.001.18.05.351.048.16.153.281c.066.079.152.141.25.18.11.047.23.07.348.07q.147 0 .289-.03.15-.035.289-.09v.32c-.04.02-.075.035-.114.05a2 2 0 0 1-.148.043c-.059.012-.113.024-.172.032-.059.004-.121.011-.184.011q-.23-.002-.449-.074a.98.98 0 0 1-.617-.597 1.4 1.4 0 0 1-.094-.54c-.004-.14.016-.285.047-.421q.045-.17.133-.329a1.06 1.06 0 0 1 .7-.492q.129-.035.265-.035m1.23-.496v-.426h.399v.426Zm.012 2.91v-2.36h.398v2.36Zm1.188 0v-3.594h.374v3.594Zm1.18-2.91v-.426h.382v.426Zm.01 2.91v-2.36h.384v2.36Zm2.087.067a1.2 1.2 0 0 1-.332-.04.9.9 0 0 1-.262-.109.8.8 0 0 1-.309-.395 1.1 1.1 0 0 1-.066-.43v-1.452h.387v1.449c0 .113.015.223.055.328.039.094.105.18.195.235.101.058.219.09.34.085a.6.6 0 0 0 .351-.093.5.5 0 0 0 .192-.254.9.9 0 0 0 .043-.301v-1.45h.386v1.454c0 .074-.008.148-.015.223a1 1 0 0 1-.043.191.9.9 0 0 1-.125.227.7.7 0 0 1-.196.175.8.8 0 0 1-.27.118 1.2 1.2 0 0 1-.331.039m3.629-.067h-.387v-1.512a.7.7 0 0 0-.035-.261.45.45 0 0 0-.094-.176.36.36 0 0 0-.152-.102.6.6 0 0 0-.196-.035.67.67 0 0 0-.375.114 1.05 1.05 0 0 0-.3.3v1.672h-.387v-2.351h.297l.074.328h.008a1.3 1.3 0 0 1 .14-.153c.051-.046.11-.09.168-.12a.84.84 0 0 1 .446-.114.74.74 0 0 1 .437.125c.121.086.211.207.266.344h.012c.093-.137.214-.258.355-.348a.95.95 0 0 1 .734-.09q.141.037.258.125.13.106.196.258a1 1 0 0 1 .074.422v1.574h-.383v-1.512a1 1 0 0 0-.035-.261.5.5 0 0 0-.098-.176.36.36 0 0 0-.152-.102.6.6 0 0 0-.195-.035.67.67 0 0 0-.375.114q-.182.118-.305.3v1.672Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e2322",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.523 4.848h1.422l.711 1.23-.71 1.23H8.522l-.71-1.23Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#cbdd72",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.523 8.016h1.422l.711 1.222-.71 1.227H8.522l-.71-1.227Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#98ca3f",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 9.574h1.419l.71 1.223-.71 1.226H11.3l-.711-1.226Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#6389c6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 6.406h1.419l.71 1.23-.71 1.235H11.3l-.711-1.23Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#e8282b",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 3.258h1.419l.71 1.222-.71 1.223H11.3L10.59 4.48Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f8c519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.05 4.848h1.446l.723 1.23-.723 1.23h-1.445l-.723-1.23Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f07525",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.05 8.016h1.446l.723 1.222-.723 1.227h-1.445l-.723-1.227Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#8162aa",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.844 6.184h-1.696l-.851 1.468.851 1.457h1.696l.86-1.457Zm-.219 2.535h-1.246l-.633-1.067.629-1.078h1.25l.629 1.078Zm.219.613h-1.696l-.851 1.469.851 1.457h1.696l.86-1.457Zm-.219 2.535h-1.246l-.633-1.066.629-1.078h1.25l.629 1.078Zm.219-8.832h-1.696l-.851 1.469.851 1.457h1.696l.86-1.457Zm-.219 2.535h-1.246l-.633-1.066.629-1.078h1.25l.625 1.078Zm2.992 2.188h-1.695l-.852 1.469.852 1.46h1.695l.856-1.46Zm-.222 2.535h-1.243l-.629-1.066.63-1.079h1.242l.628 1.079Zm.222-5.684h-1.695l-.852 1.477.852 1.465h1.695l.856-1.465Zm-.222 2.551h-1.243l-.629-1.07.63-1.086h1.242l.628 1.086Zm-5.317.598H8.387l-.848 1.469.848 1.46h1.691l.856-1.46Zm-.223 2.535H8.617l-.629-1.066.63-1.079h1.237l.625 1.079Zm.223-5.684H8.387l-.848 1.477.848 1.465h1.691l.856-1.465ZM9.855 7.16H8.617l-.629-1.074L8.618 5h1.237l.625 1.086Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#373737",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.246 20.453-.152.184a.42.42 0 0 0-.301-.149c-.2 0-.356.153-.356.352 0 .203.157.36.356.36a.46.46 0 0 0 .3-.137l.153.167a.67.67 0 0 1-.465.207.59.59 0 0 1-.61-.593c0-.332.266-.586.618-.586.168.004.34.078.457.195M8.063 20.488v.25h.558v.215h-.559v.258H8.7v.215h-.898V20.27h.883v.214h-.621ZM9.832 21.098h-.27v.328h-.261V20.27h.504c.304 0 .476.144.476.402 0 .18-.078.305-.215.375l.246.379h-.292Zm-.027-.22c.144 0 .23-.07.23-.198 0-.133-.082-.196-.23-.196h-.242v.391h.242ZM11.398 20.492v.934h-.261v-.934h-.352v-.222h.969v.222ZM12.29 21.426V20.27h.26v1.156ZM13.469 20.488v.285h.523v.22h-.523v.437h-.262v-1.16h.832v.218ZM14.59 21.426V20.27h.262v1.156ZM15.766 20.488v.25h.558v.215h-.558v.258h.636v.215h-.898V20.27h.883v.214h-.621ZM17.5 20.27c.36 0 .61.234.61.578 0 .34-.255.578-.618.578h-.484v-1.16h.492Zm-.23.937h.238c.195 0 .336-.148.336-.36 0-.21-.149-.359-.348-.359h-.226ZM6.121 22.875l-.09.227h-.27l.505-1.16h.27l.495 1.16H6.75l-.094-.227Zm.274-.664-.188.453h.367ZM8.406 22.055l-.101.215a.8.8 0 0 0-.36-.122c-.086 0-.144.032-.144.094 0 .215.617.094.617.512 0 .226-.2.351-.453.351a.82.82 0 0 1-.512-.183l.102-.215c.12.105.289.172.41.172.11 0 .172-.04.172-.11 0-.218-.614-.093-.614-.503 0-.211.18-.34.446-.34.16.004.32.05.437.129M9.855 22.055l-.097.215a.9.9 0 0 0-.363-.122c-.086 0-.145.032-.145.094 0 .215.617.094.617.512 0 .226-.199.351-.453.351a.82.82 0 0 1-.512-.183l.102-.215c.121.105.289.172.41.172.11 0 .176-.04.176-.11 0-.218-.617-.093-.617-.503 0-.211.18-.34.449-.34.16.004.32.05.433.129M11.61 22.52c0 .332-.27.59-.622.59-.355 0-.62-.255-.62-.59 0-.34.265-.59.62-.59.352 0 .621.254.621.59m-.977 0c0 .203.164.363.355.363.196 0 .352-.16.352-.363 0-.204-.16-.36-.352-.36a.355.355 0 0 0-.355.36M13.14 22.125l-.152.184a.43.43 0 0 0-.3-.153.35.35 0 0 0-.356.356c0 .203.156.36.355.36a.46.46 0 0 0 .301-.138l.153.168a.67.67 0 0 1-.465.203c-.348 0-.61-.253-.61-.59 0-.335.266-.585.618-.585.164 0 .34.074.457.195M13.695 23.098v-1.16h.262v1.16ZM14.836 22.875l-.09.227h-.27l.504-1.16h.27l.492 1.16h-.277l-.094-.227Zm.273-.664-.187.453h.367ZM16.64 22.16v.938h-.261v-.938h-.352v-.219h.97v.22ZM17.797 22.156v.254h.558v.215h-.558v.258h.637v.215h-.899v-1.16h.883v.218Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }));
};
export default SvgCertificationinline;